module.exports = __webpack_public_path__ + "static/img/TUDA2022.bd1c01db.png";